export default "__VITE_ASSET__2493d782__"